import React from "react";
import {
  Property,
  PropertyValue,
} from "features/BuildingProductEditor/ProductEditorStore";
import SelectedItem from "./SelectedItem";
import DropdownList, { Option } from "./DropdownList";
import { useTranslation } from "react-i18next";
import useSelect from "./useSelect";

const MultiSelect = ({
  property,
  onChange,
}: {
  property: Property;
  onChange: (value: PropertyValue) => void;
}) => {
  const { t } = useTranslation();
  const selectedItems = (property.value as string[]) || [];

  const handleRemoveOption = async (item: Option | null) => {
    if (item === null) return;
    const filteredSelected = selectedItems.filter((rec) => rec !== item.name);
    onChange(filteredSelected);
    const filteredOptions = options.filter((rec) => rec.id !== item.id);
    await updateOptions(filteredOptions);
  };

  const {
    removeConfirmPopup,
    options,
    updateOptions,
    handleSearchTerm,
    onClickRemoveOption,
  } = useSelect(property, handleRemoveOption);

  const handleChangeValue = (item: Option) => {
    const itemSelected = selectedItems.find((rec) => rec === item.name);
    if (!itemSelected) onChange([...selectedItems, item.name]);
    if (item?.id === "search_term") handleSearchTerm(item);
  };

  const handleRemoveSelectedItem = (item: string) => {
    onChange(selectedItems.filter((rec) => rec !== item));
  };

  return (
    <div className="w-full bg-white flex min-h-full">
      <DropdownList
        containerClassName="w-full"
        options={options}
        onChangeItems={handleChangeValue}
        onRemoveOption={onClickRemoveOption}
        selectedItems={selectedItems}
        placeholder={selectedItems.length ? "" : t("productEditor.empty")}
      >
        {selectedItems.length
          ? selectedItems?.map((rec, index) => (
              <SelectedItem
                key={index}
                rec={rec}
                removeItem={handleRemoveSelectedItem}
              />
            ))
          : null}
      </DropdownList>

      {removeConfirmPopup()}
    </div>
  );
};

export default MultiSelect;
